// src/routes/routeConfig.js
export const allRoutes = [
  // ---- عامة ----
  {
    path: "/",
    title: "Login",
    componentName: "LoginPage",
    public: true,
    requiredPermissions: [],
  },
  {
    path: "/forgot-password",
    title: "Forgot Password",
    componentName: "ForgotPassword",
    public: true,
    requiredPermissions: [],
  },
  {
    path: "/reset-password",
    title: "Reset Password",
    componentName: "ResetPassword",
    public: true,
    requiredPermissions: [],
  },
  {
    path: "/404",
    title: "Not Found",
    componentName: "NotFound",
    public: true,
    requiredPermissions: [],
  },
  // ---- إدارة المخزون ----
  {
    path: "/packaging-materials",
    title: "مواد التغليف",
    componentName: "PackagingMaterials",
    public: false,
    requiredPermissions: ["ahlam", "depo", "senior"],
  },
  {
    path: "/raw-materials",
    title: "المواد الخام",
    componentName: "RawMaterials",
    public: false,
    requiredPermissions: ["ahlam", "depo", "senior"],
  },
  {
    path: "/ready-materials",
    title: "منتجات جاهزة",
    componentName: "ReadyMaterials",
    public: false,
    requiredPermissions: ["ahlam", "depo", "senior"],
  },
  {
    path: "/product-names",
    title: "أسماء مواد التغليف",
    componentName: "ProductNames",
    public: false,
    requiredPermissions: ["ahlam", "depo", "senior"],
  },
  {
    path: "/raw-material-names",
    title: "أسماء المواد الخام",
    componentName: "RawMaterialNames",
    public: false,
    requiredPermissions: ["ahlam", "depo", "senior"],
  },
  {
    path: "/ready-material-names",
    title: "أسماء المواد الجاهزة",
    componentName: "ReadyMaterialNames",
    public: false,
    requiredPermissions: ["ahlam", "depo", "senior"],
  },
  // ---- الطلبيات ----
  {
    path: "/orders",
    title: "الطلبيات",
    componentName: "Orders",
    public: false,
    // front-end gate: ahlam (مشاهدة) و senior (إدارة)
    requiredPermissions: ["ahlam", "senior"],
  },
  {
    path: "/users",
    title: "المستخدمين",
    componentName: "Users",
    public: false,
    requiredPermissions: ["ahlam", "senior"],
  },
  // ---- معاملات المخزن ----
  {
    path: "/depo-transactions",
    title: "معاملات المخزن",
    componentName: "DepoTransactions",
    public: false,
    requiredPermissions: ["ahlam", "depo", "senior", "production"],
  },
];

// ---- الصلاحيات ----
// الوصول = (لا صلاحيات مطلوبة) أو (لدى المستخدم "All") أو (يمتلك جميع الصلاحيات المطلوبة)
export function hasPageAccess(userPermissions = [], required = []) {
  if (!required || required.length === 0) return true;
  if (userPermissions.includes("all")) return true;
  return required.every((p) => userPermissions.includes(p));
}

// لإظهار العناصر المسموحة (مثالي لبناء السايدبار)
export function getAvailableRoutesForUser(userPermissions = []) {
  return allRoutes.filter((r) => {
    if (r.public) return false; // لا نعرض العامة في السايدبار
    return hasPageAccess(userPermissions, r.requiredPermissions);
  });
}
